import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { putHtmlCodeToDom } from "@devowl-wp/headless-content-unblocker";
import { getServiceSelection } from "../decision";
import { OPT_OUT_EVENT } from "../events";
import { deleteCookiesLocally, getManagerDependingVariables } from ".";
/**
 * Opt-in to a set of cookies for a given data manager like GTM / MTM.
 */

function applyOptOut(_x, _x2) {
  return _applyOptOut.apply(this, arguments);
}

function _applyOptOut() {
  _applyOptOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(options, isManagerOptOut) {
    var _getServiceSelection, isManagerActive, iterateCookies, tagManager, _getManagerDependingV, useVariableNamePascal, deleteHttpCookies;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _getServiceSelection = getServiceSelection(options), isManagerActive = _getServiceSelection.isManagerActive, iterateCookies = _getServiceSelection.iterateCookies;
            tagManager = options.tagManager;
            _getManagerDependingV = getManagerDependingVariables(isManagerActive, tagManager), useVariableNamePascal = _getManagerDependingV.useVariableNamePascal; // Handle opt-outs sequentially

            deleteHttpCookies = [];
            _context2.next = 6;
            return iterateCookies( /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(group, cookie, isOptIn) {
                var id, codeDynamics, codeOptOut, codeOptOutDelete, noTechnicalDefinitions, technicalDefinitions, rest, isOnlyWhenNoConsentToManager;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        id = cookie.id, codeDynamics = cookie.codeDynamics, codeOptOut = cookie.codeOptOut, codeOptOutDelete = cookie.codeOptOutDelete, noTechnicalDefinitions = cookie.noTechnicalDefinitions, technicalDefinitions = cookie.technicalDefinitions, rest = _objectWithoutProperties(cookie, ["id", "codeDynamics", "codeOptOut", "codeOptOutDelete", "noTechnicalDefinitions", "technicalDefinitions"]);

                        if (!isOptIn) {
                          // Check if the script should explicitly only be loaded if no consent is given to the manager
                          isOnlyWhenNoConsentToManager = isManagerActive && rest["codeOptInNo".concat(useVariableNamePascal)];

                          if (isOnlyWhenNoConsentToManager && !isManagerOptOut || !isOnlyWhenNoConsentToManager) {
                            putHtmlCodeToDom(codeOptOut, codeDynamics);
                          }

                          if (codeOptOutDelete && !noTechnicalDefinitions) {
                            deleteCookiesLocally(technicalDefinitions, codeDynamics); // Mark deletable server-side cookies

                            // Mark deletable server-side cookies
                            if (technicalDefinitions.some(function (_ref2) {
                              var type = _ref2.type;
                              return type === "http";
                            })) {
                              deleteHttpCookies.push(id);
                            }
                          }

                          document.dispatchEvent(new CustomEvent(OPT_OUT_EVENT, {
                            detail: {
                              group: group,
                              cookie: cookie,
                              deleteHttpCookies: deleteHttpCookies
                            }
                          }));
                        }

                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x3, _x4, _x5) {
                return _ref.apply(this, arguments);
              };
            }());

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _applyOptOut.apply(this, arguments);
}

export { applyOptOut };